import React from 'react';
import '../styles/Subscriptions.css';

const AdminSubscriptions = () => {
  const subs = ['subscriber1@email.com','subscriber2@email.com','subscriber3@email.com','subscriber4@email.com','subscriber5@email.com'];
  return (
    <div className="subscriptions-page">
      <h1>Subscriptions</h1>
      <p>Manage newsletter subscribers.</p>
      <table className="subscriptions-table">
        <thead><tr><th>#</th><th>Email</th><th>Date Subscribed</th><th>Status</th><th>Actions</th></tr></thead>
        <tbody>{subs.map((email,i)=>(<tr key={i}><td>{i+1}</td><td>{email}</td><td>April {10-i}, 2026</td><td>Active</td><td><button className="remove-btn">Remove</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default AdminSubscriptions;
